import { zUid } from "src/types/zUid";
import { z } from "zod";

const zCbvDictGroup = z.object({
  id: zUid,
  name: z.string(),
});
export type ZCbvDictGroup = z.infer<typeof zCbvDictGroup>;

const zCbvParentAttr = z.object({
  id: zUid,
  name: z.string(),
  restrictionName: z.string().nullish(),
  groupByDictionary: zCbvDictGroup.array().nullish(),
  viewStyles: z.string().nullish(),
});
export type ZCbvParentAttr = z.infer<typeof zCbvParentAttr>;

export const zAvaliableCopyAttrData = z.object({
  linkAttributeId: zUid,
  linkAttributeName: z.string(),
  attributes: zCbvParentAttr.array().nullish(),
});
export type ZAvaliableCopyAttrData = z.infer<typeof zAvaliableCopyAttrData>;
